import { getState } from 'redux/core'
import actions from 'redux/actions'
import { getCookieValue } from 'helpers'
import { constants, fbq, sentry } from 'common/helpers'


// TODO move this logic to usePurchaseAnalytics hook 15.06.2020 @akopylov
const callAnalytics = async () => {
  const data = getState().models.purchaseData.paymentData

  const {
    paymentType, isResubscribe, actualPrice, totalAmount,
    ecommerceOrderId, ecommerceOrderNumber,
  } = data

  const isMakeupIntroFlowEnabled  = Boolean(getCookieValue(constants.cookieNames.makeupIntroFlow))
  const isSkincareIntroFlow       = Boolean(getCookieValue(constants.cookieNames.skincareIntroFlow))
  const totalAmountDollars        = parseFloat(actualPrice) || totalAmount / 100

  const { models: { me: { gender } } } = getState()

  console.info('callAnalytics')

  /* Facebook --------------------------------- */

  if (paymentType === constants.paymentTypes.subscription && !isResubscribe) {
    const purchaseEventPayload = {
      value: totalAmountDollars,
      currency: 'USD',
      content_type: 'subscription',
      gender: gender === 'female' ? 'woman' : 'men',
    }

    fbq.track('Purchase', purchaseEventPayload)
    fbq.track('Purchase Scentbird', purchaseEventPayload) // new requirement from Sergei

    // SCNT-4951
    if (isMakeupIntroFlowEnabled || isSkincareIntroFlow) {
      fbq.trackWithPixel('Purchase', constants.facebookPixels.standard, purchaseEventPayload)
      fbq.track('Scentbird Makeup')
    }
  }

  if (paymentType === constants.paymentTypes.giftSubscription) {
    fbq.track('PurchaseGiftSubscription', {
      value: totalAmountDollars,
      currency: 'USD',
    })
  }

  if (paymentType === constants.paymentTypes.giftCard) {
    fbq.track('PurchaseGiftCard', {
      value: totalAmountDollars,
      currency: 'USD',
      ids: `gift_card_${totalAmountDollars}`,
    })
  }

  if (
    ecommerceOrderNumber && ecommerceOrderId && (
      paymentType === constants.paymentTypes.ecommerce
      || paymentType === constants.paymentTypes.subscriptionAndEcommerce
    )
  ) {
    try {
      const { ids } = await actions.models.payment.fetchOrderListIds(ecommerceOrderId)

      fbq.track('PurchaseEcommerce', {
        value: totalAmountDollars,
        content_ids: ids || [],
        currency: 'USD',
      })
    }
    catch (err) {
      const error = (err && err.stack) ? err.stack : err
      sentry.captureException('Error in fetchOrderListIds', {
        extra: {
          error,
        },
      })
    }
  }
}


export default callAnalytics
